<template>
    <div :class="themeClass" class="vc-cart-items">
        <base-transition-expand>
            <div class="vc-cart-items__section" v-if="beats.length > 0">
                <div class="vc-cart-items__section__header">
                    <span class="vc-cart-items__section__header__title">Beats</span>
                    <cart-controls theme="checkout"
                                   v-if="this.theme === 'checkout' && firstSection === 'beats'"></cart-controls>
                </div>
                <transition-group
                        @after-enter="itemAfterEnter"
                        @enter="itemEnter"
                        @leave="itemLeave"
                        name="c-expand-transition">
                    <div :key="cartItem.item.id" v-for="(cartItem, index) in beats">
                        <cart-item :cartItem="cartItem"
                                   :theme="theme"
                                   @removeCartItem="cart.removeItem($event)"
                                   class="vc-cart-items__section__item"></cart-item>
                    </div>
                </transition-group>
            </div>
        </base-transition-expand>
        <base-transition-expand>
            <div class="vc-cart-items__section" v-if="soundkits.length > 0">
                <div class="vc-cart-items__section__header">
                    <span class="vc-cart-items__section__header__title">Sound Packs</span>
                    <cart-controls theme="checkout"
                                   v-if="this.theme === 'checkout' && firstSection === 'soundkits'"></cart-controls>
                </div>
                <transition-group
                        @after-enter="itemAfterEnter"
                        @enter="itemEnter"
                        @leave="itemLeave"
                        name="c-expand-transition">
                    <div :key="cartItem.item.id" v-for="(cartItem, index) in soundkits">
                        <cart-item :cartItem="cartItem"
                                   :theme="theme"
                                   @removeCartItem="cart.removeItem($event)"
                                   class="vc-cart-items__section__item"></cart-item>
                    </div>
                </transition-group>
            </div>
        </base-transition-expand>
        <base-transition-expand>
            <div class="vc-cart-items__section" v-if="songs.length > 0">
                <div class="vc-cart-items__section__header">
                    <span class="vc-cart-items__section__header__title">Songs</span>
                    <cart-controls theme="checkout"
                                   v-if="this.theme === 'checkout' && firstSection === 'songs'"></cart-controls>
                </div>
                <transition-group
                        @after-enter="itemAfterEnter"
                        @enter="itemEnter"
                        @leave="itemLeave"
                        name="c-expand-transition">
                    <div :key="cartItem.item.id" v-for="(cartItem, index) in songs">
                        <cart-item :cartItem="cartItem"
                                   :theme="theme"
                                   @removeCartItem="cart.removeItem($event)"
                                   class="vc-cart-items__section__item"></cart-item>
                    </div>
                </transition-group>
            </div>
        </base-transition-expand>
        <base-transition-expand>
            <div class="vc-cart-items__section" v-if="beatTapes.length > 0">
                <div class="vc-cart-items__section__header">
                    <span class="vc-cart-items__section__header__title">Beat Tapes</span>
                    <cart-controls theme="checkout"
                                   v-if="this.theme === 'checkout' && firstSection === 'beattapes'"></cart-controls>
                </div>
                <transition-group
                        @after-enter="itemAfterEnter"
                        @enter="itemEnter"
                        @leave="itemLeave"
                        name="c-expand-transition">
                    <div :key="cartItem.item.id" v-for="(cartItem, index) in beatTapes">
                        <cart-item :cartItem="cartItem"
                                :key="cartItem.item.id"
                                :theme="theme"
                                @removeCartItem="cart.removeItem($event)"
                                class="vc-cart-items__section__item"></cart-item>
                    </div>
                </transition-group>
            </div>
        </base-transition-expand>
        <base-transition-expand>
            <div class="vc-cart-items__section" v-if="services.length > 0">
                <div class="vc-cart-items__section__header">
                    <span class="vc-cart-items__section__header__title">Services</span>
                    <cart-controls theme="checkout"
                                   v-if="this.theme === 'checkout' && firstSection === 'services'"></cart-controls>
                </div>
                <transition-group
                    @after-enter="itemAfterEnter"
                    @enter="itemEnter"
                    @leave="itemLeave"
                    name="c-expand-transition">
                    <div :key="cartItem.item.id" v-for="(cartItem, index) in services">
                        <cart-item :cartItem="cartItem"
                                   :theme="theme"
                                   @removeCartItem="cart.removeItem($event)"
                                   class="vc-cart-items__section__item"></cart-item>
                    </div>
                </transition-group>
            </div>
        </base-transition-expand>
    </div>
</template>

<script>
    import Configure from './../../mixins/configure'

    import CartItem from './cart-item.vue'
    import Coupons from '../../mixins/coupons.vue'
    import TransitionExpand from '../../mixins/transition-expand.vue'
    import BaseTransitionExpand from '../base/base-transition-expand.vue'
    import CartControls  from './cart-controls.vue'

    export default {
        name: "cart-items-list",
        props: {
            modal: {
                type: Boolean,
                default: false
            },
            theme: {
                type: String,
                default: 'cartPopup',
                validator: function (value) {
                    return ['cartPopup', 'checkout'].indexOf(value) !== -1;
                }
            }
        },
        mixins: [
            Coupons, Configure, TransitionExpand
        ],
        components: {
            CartItem, CartControls, BaseTransitionExpand
        },
        data() {
            return {
                modalLicense: null,
            }
        },
        computed: {
            beats() {
                return this.cartItems.filter((item) => item.type === 'beat');
            },
            songs() {
                return this.cartItems.filter((item) => item.type === 'song');
            },
            soundkits() {
                return this.cartItems.filter((item) => item.type === 'soundkit');
            },
            beatTapes() {
                return this.cartItems.filter((item) => item.type === 'collection' || item.type === 'beattapes');
            },
            services() {
                return this.cartItems.filter((item) => ['service', 'service_quote'].includes(item.type));
            },
            cartItems() {
                return this.cart.cart;
            },
            cart() {
                return this.$store.state.cart;
            },
            playlistManager() {
                return this.$store.state.playlistManager;
            },
            coupon() {
                return this.$store.state.cart.coupon;
            },
            firstSection() {
                if (this.beats.length > 0)
                    return 'beats';
                else if (this.soundkits.length > 0)
                    return 'soundkits';
                else if (this.songs.length > 0)
                    return 'songs';
                else if (this.beatTapes.length > 0)
                    return 'beattapes';
                else if (this.services.length > 0)
                    return 'services';
            },
            themeClass() {
                return {
                    'vc-cart-items--cart-popup-theme': this.theme === 'cartPopup',
                    'vc-cart-items--checkout-theme': this.theme === 'checkout',
                }
            }
        },
        watch: {
            cartItems: function (items, oldItems) {
                if (!this.modal) {
                    let playlist = this.playlistManager.getPagePlaylist();
                    playlist?.addPlaylistItems(items.map(i => i.item));
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .vc-cart-items {
        $cart-items: &;

        &__section {
            & + & {
                margin-top: 10px;
            }

            &__header {
                // Box
                display: flex;
                justify-content: space-between;
                padding-bottom: 2.5px;
                border-bottom: {
                    width: 1px;
                    style: solid;
                }
                margin-bottom: 10px;

                &__title {
                    // Text
                    font-size: 16px;
                    font-weight: 600;

                    // Others
                    user-select: none;
                }
            }

            &__item {
                margin-left: 5px;
                margin-top: 10px;
            }
        }

        &--cart-popup-theme {
            #{$cart-items}__section {
                &__header {
                    border-color: var(--menu-item-text-color-faded-more);

                    &__title {
                        font-size: 16px;
                        color: var(--menu-item-text-color-faded);
                    }
                }
            }
        }

        &--checkout-theme {
            #{$cart-items}__section {
                &__header {
                    border-color: var(--primary-text-color-faded-more);

                    &__title {
                        font-size: 18px;
                        color: var(--primary-text-color-emphasized);
                    }
                }
            }
        }
    }

    // Transition Smoothness
    * {
        will-change: height;
        /*transform: translateZ(0);*/
        backface-visibility: hidden;
        /*perspective: 1000px;*/
    }
</style>
